export const USER_MODALS_EVENT = 'modals:users';

export const MODIFY_PERMISSION_GROUP_MODAL_EVENT = `${USER_MODALS_EVENT}:modify-permission-group`;
export const MODIFY_PERMISSION_GROUP_MODAL_EVENT_OPEN = `${MODIFY_PERMISSION_GROUP_MODAL_EVENT}:open`;
export const MODIFY_PERMISSION_GROUP_MODAL_EVENT_CLOSE = `${MODIFY_PERMISSION_GROUP_MODAL_EVENT}:close`;
